import { render, staticRenderFns } from "./filelist-component.vue?vue&type=template&id=6d8dfa80&scoped=true"
import script from "./filelist-component.vue?vue&type=script&lang=js"
export * from "./filelist-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8dfa80",
  null
  
)

export default component.exports